// extracted by mini-css-extract-plugin
module.exports = {"layout":"style_layout__2dQib","exclamation":"style_exclamation__200zi","button":"style_button__1khmM"};